export const getDescriptionId = (fieldId: string) => `${fieldId}-description`;

export const getFeedbackErrorId = (fieldId: string) => `${fieldId}-feedback-error`;
